module.exports = __webpack_public_path__ + "servicos-prestados.c9ed17136675afc97ade.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/servicos-prestados.jpg
// module id = ../../../../../src/assets/images/backgrounds/servicos-prestados.jpg
// module chunks = styles